import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Layout, { PageHeader } from "@/components/Layout";
import { StatusBadge } from "@/components/StatusBadge";
import { Progress } from "@/components/ui/progress";
import { ListChecks } from "@phosphor-icons/react";

export default function Jobs() {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const load = () => api.get("/jobs").then((r) => setJobs(r.data));
    load();
    const iv = setInterval(load, 3000);
    return () => clearInterval(iv);
  }, []);

  return (
    <Layout>
      <PageHeader title="Migration Jobs" subtitle="Monitor & control migration runs" />
      <div className="p-8">
        {jobs.length === 0 ? (
          <div className="bg-white border border-dashed border-stone-300 rounded-xl py-20 text-center">
            <ListChecks size={40} className="mx-auto text-stone-300" />
            <p className="text-stone-500 mt-4 text-sm">No migration jobs yet.</p>
          </div>
        ) : (
          <div className="bg-white border border-stone-200 rounded-2xl shadow-card overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs uppercase tracking-wider text-stone-500 border-b border-stone-200">
                  <th className="px-6 py-3 font-semibold">Project</th>
                  <th className="px-6 py-3 font-semibold">Mode</th>
                  <th className="px-6 py-3 font-semibold">Status</th>
                  <th className="px-6 py-3 font-semibold w-48">Progress</th>
                  <th className="px-6 py-3 font-semibold text-right">Success</th>
                  <th className="px-6 py-3 font-semibold text-right">Failed</th>
                  <th className="px-6 py-3 font-semibold text-right">Started</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((j) => (
                  <tr key={j.id} data-testid={`job-row-${j.id}`} className="border-b border-stone-100 hover:bg-stone-50 transition-colors duration-200">
                    <td className="px-6 py-4">
                      <Link to={`/jobs/${j.id}`} className="font-medium text-stone-900 hover:text-[#C2410C]">{j.project_name}</Link>
                    </td>
                    <td className="px-6 py-4 capitalize text-stone-600">{j.mode}</td>
                    <td className="px-6 py-4"><StatusBadge status={j.status} /></td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <Progress value={j.progress_pct} className="h-1.5 rounded-xl" />
                        <span className="font-mono text-xs text-stone-500 w-10">{j.progress_pct}%</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-right font-mono text-emerald-600">{j.successful}</td>
                    <td className="px-6 py-4 text-right font-mono text-rose-600">{j.failed}</td>
                    <td className="px-6 py-4 text-right text-xs text-stone-400">{j.created_at ? new Date(j.created_at).toLocaleString() : ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
